import '@fortawesome/fontawesome-free/css/all.css';
import Vue from 'vue';
import Vuetify, { VSnackbar, VBtn, VIcon } from 'vuetify/lib';
import VuetifyToast from 'vuetify-toast-snackbar-ng';
import VuetifyOverlay from 'vuetify-overlay';
import VuetifyConfirm from 'vuetify-confirm';
import { Ripple } from 'vuetify/lib/directives';

const vuetify = new Vuetify();

Vue.use(Vuetify, {
  components: {
    VSnackbar,
    VBtn,
    VIcon,
  },
  directives: {
    Ripple,
  },
});

Vue.use(VuetifyToast, {
  x: 'center',
});

Vue.use(VuetifyOverlay);

Vue.use(VuetifyConfirm, { vuetify });

export default new Vuetify({});
